import { DateStringCreator as dateStringCreator } from "@utils/DateStringCreator";

export class TitleBannerMagazine {
  private ctx: HTMLElement;

  constructor(element: HTMLElement) {
    this.ctx = element;
  }

  init(): this {
    this.setPublicationDateString();
    return this;
  }

  private setPublicationDateString(): void {
    const publicationDateIso = this.ctx.dataset.publicationDateIso ?? "";
    const labelToday = this.ctx.dataset.labelToday ?? "";
    const labelDaysAgo = this.ctx.dataset.labelDaysAgo ?? "";
    const dateSpan = this.ctx.querySelector<HTMLElement>(".publication-date");

    const publicationDateString = dateStringCreator.createDateFromLabels(
      publicationDateIso,
      labelToday,
      labelDaysAgo,
    );

     if (dateSpan) {
       if (publicationDateString.length > 0) {
         dateSpan.textContent = publicationDateString;
       }
       dateSpan.style.display = "";
    }
  }

  destroy(): void {}

  static initAll(): void {
    document
      .querySelectorAll<HTMLElement>('[data-component="title-banner-magazine"]')
      .forEach((el) => new TitleBannerMagazine(el).init());
  }
}
